<template>
    <div name="concierge" class="concierge">
        <img v-if="showcase === 'bodyfriend'" class="back" src="../../assets/showcase/xi/concierge_back_bodyfriend.png" @click="goHome"/>
        <img v-else class="back" src="../../assets/showcase/xi/concierge_back.png" @click="goHome"/>
    </div>
</template>

<script>
export default {
    name: 'concierge',
    computed: {
        showcase: function() {
            return this.$route.params.showcase
        }
    },
    methods: {
        goHome: function()
        {
            this.$emit('goHome')
        }
    }
}
</script>

<style scoped>
    .concierge {
        width: 100%;
    }
    .back{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Concierge.vue